var path = '/Users/linda/git/Sunflower/prisms-crt/prisms-client-components-ng/demo/demo.html';
var html = "<div id=\"ui-wrapper\" ng-class=\"{'logged-out': $ctrl.isAuthenticated !== 'true' }\">\n\t<div ui-view>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;